import React from 'react';
import { createPortal } from 'react-dom';
import './Modal.css';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  customFooter?: React.ReactNode; // Footer personalizado
  /** Clases extra para el contenedor del contenido (ej. "admin-panel dark-theme" para estilos dark en portal) */
  contentClassName?: string;
  /** Si es false, clic en el fondo no cierra el modal (por defecto true). */
  closeOnBackdropClick?: boolean;
}
const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  onConfirm,
  confirmText = 'Entendido',
  cancelText = 'Cancelar',
  customFooter,
  contentClassName = '',
  closeOnBackdropClick = true,
}) => {
  if (!isOpen) return null;
  const content = (
    <div
      className="modal-overlay"
      onClick={closeOnBackdropClick ? onClose : undefined}
    >
      <div className={`modal-content${contentClassName ? ` ${contentClassName}` : ''}`} onClick={(e) => e.stopPropagation()}>
        {title && <h3 className="modal-title">{title}</h3>}
        <div className="modal-body">{children}</div>
        {customFooter ? (
          <div className="modal-footer">{customFooter}</div>
        ) : onConfirm ? (
          <div className="modal-footer">
            {cancelText && (
              <button
                className="modal-button modal-button-secondary"
                onClick={onClose}
              >
                {cancelText}
              </button>
            )}
            <button
              className="modal-button"
              onClick={onConfirm}
            >
              {confirmText}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
  return createPortal(content, document.body);
};
export default Modal;
